import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Sending Requests**

HawkClient allows you to send **REST** and **GraphQL** requests with ease.

Choose your HTTP method (**GET**, **POST**, **PUT**, etc.), enter the endpoint, and configure
the request **body**, **headers**, and **query parameters** as needed.

Once everything is set, click **Send** to view the response details, including:
- Status code
- Response headers
- Response body

![Sending Requests in HawkClient](/send-requests/SendRequest.png)
`;

const OverviewTab = () => {
    return (
        <MarkDownRenderer
            title="Overview"
            markDownText={markdownContent}
        />
    );
};

export default OverviewTab;
